module.exports = __webpack_public_path__ + "img/btpn-logo.9a0df340.png";